import { render } from "./AdminInput.vue?vue&type=template&id=577220ba"
import script from "./AdminInput.vue?vue&type=script&lang=js"
export * from "./AdminInput.vue?vue&type=script&lang=js"

import "./AdminInput.vue?vue&type=style&index=0&id=577220ba&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__